<template>
	<div class="home main">
		<van-sticky>
			<div class="search-wrap">
				<img class="icon-search" src="@static/images/business/icon_search.png" alt="">
				<van-search v-model="searchParams.condition" @input='search' placeholder="搜索客户姓名或手机号">
				</van-search>
			</div>
		</van-sticky>
		<van-pull-refresh v-model="refreshing" @refresh="onReferesh">
			<van-list v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了" @load="nextPage">
				<div v-if="list.length && searchParams.orderby == 1" class="customer-list">
					<van-index-bar :index-list="indexList">
						<div v-for="(key,keyIndex) in indexList"  :key="keyIndex" >
							<van-index-anchor class="title-box" :index="key">{{key}}</van-index-anchor>
							<div class="customer-wrap">
								<div v-for="(item,itemIndex) in customerListMap[key]" :key="itemIndex" class="customer-box"
									@click="goDetail(item)">
									<div class="box">
										<img v-if="item.sex == 1" class="customer-head"
											src='@static/images/business/header_1.png'></img>
										<img v-else-if="item.sex == 2" class="customer-head"
											src='@static/images/business/header_2.png'></img>
										<img v-else class="customer-head"
											src='@static/images/business/head_default.png'></img>
										<div class="right-wrap">
											<div class="name-wrap">
												<span class="name">{{item.name}}</span>
												<img v-if="item.icon" :src="item.icon" alt="">
												<img v-else-if="item.sex == 1" class="icon-sex"
													src='@static/images/business/icon_sex_2.png'></img>
												<img v-else-if="item.sex == 2" class="icon-sex"
													src='@static/images/business/icon_sex_1.png'></img>
												<span v-if="item.type == 2" class="label">自有</span>
												<span v-else-if="item.type == 1" class="label yuyue">预约</span>
											</div>
											<div class="">
												<span class="phone">{{item.mobile}}</span>
											</div>
										</div>
									</div>
									<span v-if="FOLLOW_STATUS[item.followStatus]"
										class="label-status">{{FOLLOW_STATUS[item.followStatus]}}</span>
									<img v-if="item.isCommunicate == 1" class="icon-notice"
										src='@static/images/business/icon_notice.png'></img>
									<p v-if="item.isSuccess == 0" class="status">
										{{AGENT_CUSTOMER_QUERY_TYPE[item.isSuccess]}}
									</p>
									<p v-else-if="item.isSuccess == 1" class="status">成交<span
											orange>{{item.successNum}}</span>单&nbsp;&nbsp;累计保费<span
											orange>{{item.successFee}}</span>元</p>
								</div>
							</div>
						</div>
					</van-index-bar>
					<p class="total">共有{{list.length}}名客户</p>
				</div>

			</van-list>
			<div v-else-if="list.length == 0 && searchParams.condition" class="empty-box">
				<img src="@static/images/business/empty_2.png" alt="">
				<p>暂无搜索结果</p>
			</div>
		</van-pull-refresh>
	</div>
</template>
<script>
	var time;
	import {
		loading,
		common
	} from "@/api/mixins";
	import filter from "@/api/filter";
	export default {
		mixins: [loading, common],
		data() {
			return {
				FOLLOW_STATUS: {},
				AGENT_CUSTOMER_QUERY_TYPE: {},
				list: [],
				customerListMap: {},
				refreshing: false, //下拉刷新
				finished: true, //是否完成上拉加载
				searchParams: { //列表查询参数
					orderby: 1, //排序方式,@notes1-姓名正序2-沟通时间倒序
					type: null, //客户类型,@notes1-预约2-自有
					isSuccess: null, //成交状态,@notes0-未成交1-已成交
					pageSize: 10,
					pageNo: 1,
					isHosting: '', //托管状态
					followStatus: [], //跟进状态
					birthDateType: '', //生日
					nextChatDateType: '', //下次沟通过时间
					source: [], //客户来源
					condition: ''
				},
				totalNo: '', //总页数
			};
		},
		created() {
			this.getDicByType({
				type: "FOLLOW_STATUS"
			}).then(res=>{
				this.FOLLOW_STATUS = res;
			})
			this.getDicByType({
				type: "AGENT_CUSTOMER_QUERY_TYPE"
			}).then(res=>{
				this.AGENT_CUSTOMER_QUERY_TYPE = res;
			})
		},
		methods: {
			goDetail(item) {
				this.$router.push({
					path: '/apps/business/customerDetail',
					query: {
						id: item.id
					}
				})
			},
			search(val) {
				clearTimeout(time);
				time = setTimeout(() => {
					this.getList(false);
				}, 1000)
			},
			//上拉加{载
			nextPage() {
				if (this.searchParams.pageNo == this.totalNo) {
					this.finished = true;
					return;
				}
				this.searchParams.pageNo++;
				this.getList(false)
			},
			//下拉刷新
			onReferesh() {
				this.refreshing = true;
				this.searchParams.pageNo = 1;
				this.getList(false);
			},
			getList(loading = true) {
				console.log(loading);
				if (!this.searchParams.condition) {
					this.list = [];
					this.customerListMap = {};
					this.indexList = [];
					return;
				}
				this.loading = loading;
				this.$http({
					type: "POST",
					url: "/app/customer/myCustomerList",
					data: {
						...this.searchParams,
						followStatus: this.searchParams.followStatus.join(),
						source: this.searchParams.source.join()
					}
				}).then(res => {
					this.searchParams.pageNo = res.current;
					this.totalNo = res.pages;
					if (res.current == 1) {
						this.list = [];
						this.customerListMap = {};
						this.indexList = [];
					}
					this.list = [...this.list, ...res.data].map(item => {
						let key = item.nameFirst.substr(0, 1);
						if (this.indexList.indexOf(key) == -1) {
							this.indexList = [...this.indexList, key]
						}
						// this.customerListMap[key].list = this.customerListMap[key].list ? [item] : [...this
						// 	.customerListMap[key].list, item
						// ]
						if (this.customerListMap[key]) {
							this.customerListMap[key] = [...this.customerListMap[key], item]
						} else {
							this.customerListMap[key] = [item]
						}
						return {
							...item,
							firstKey: key
						}
					});
					console.log('--------------', this.customerListMap)
					// console.log('----',this.customerListMap);
					this.refreshing = false;
					this.loading = false;
					if (res.current === res.pages) {
						this.finished = true;
					} else {
						this.finished = false;
					}
				}).catch(() => {
					this.loading = false;
					this.refreshing = false;
					this.finished = true;
				})
			}
		},
		components: {},
	};
</script>

<style lang="scss" scoped>
	/deep/.search-wrap {
		background-color: #fff;
		.van-search {
			padding: 20px 30px;
		}
	
		.van-search__content {
			width: 690px;
			height: 66px;
			background: rgba(243, 243, 243, 0.39);
			border-radius: 8px;
			line-height: 66px;
			padding-left: 64px;
		}
	
		.icon-search {
			width: 24px;
			position: absolute;
			left: 50px;
			top: 40px;
		}
	
		.van-field__left-icon {
			display: none;
		}
	}
	.empty-box {
		text-align: center;
	
		img {
			margin-top: 286px;
			width: 420px;
			height: 180px;
		}
	
		p {
			text-align: center;
			margin-top: 40px;
			font-size: 28px;
			line-height: 40px;
			color: #727C8E;
		}
	}
	.customer-box {
		border-bottom: 1px solid #ECECEC;
		margin: 0 28px 0 32px;
		padding: 30px 0;
		position: relative;

		.icon-notice {
			position: absolute;
			width: 32px;
			height: 32px;
			bottom: 30px;
			right: 40px;
		}

		.label-status {
			position: absolute;
			top: 54px;
			right: 40px;
			display: inline-block;
			font-size: 26px;
			line-height: 30px;
			color: #236DFF;
			height: 40px;
			background: rgba(229, 237, 255, 0.5);
			border-radius: 3px;
			line-height: 40px;
			padding: 0 10px;
		}

		.box {

			display: flex;
			align-items: center;
		}

		.customer-head {
			flex: 0 0 86px;
			height: 86px;
			margin-right: 14px;
			border-radius: 50%;
		}

		.right-wrap {
			display: flex;
			flex-direction: column;
			justify-content: center;

			font-size: 28px;
			color: #17233D;

			.name-wrap {
				display: flex;
				align-items: center;
				margin-bottom: 10px;

				.name {
					font-size: 32px;
					font-weight: 600;
					line-height: 45px;
				}

				.icon-sex {
					width: 24px;
					height: 24px;
					margin: 0 0 0 10px;
				}

				.label {
					margin-left: 14px;
					text-align: center;
					line-height: 30px;
					width: 64px;
					height: 30px;
					background: linear-gradient(143deg, #16D8A5 0%, #23BE95 100%);
					border-radius: 2px;
					display: inline-block;
					font-size: 22px;
					color: #FFFFFF;
				}

				.yuyue {
					background: linear-gradient(143deg, #FD9258 0%, #FC5E00 100%);
				}
			}

			.phone {
				line-height: 32px;
				margin-right: 50px;
				font-size: 28px;
			}


		}

		.status {
			margin-top: 20px;
			line-height: 32px;
			font-size: 26px;
			color: #AAAAAA;
		}
	}

	.customer-wrap {
		&>:last-child {
			border-bottom: none;
		}
	}

	.total {
		margin: 0 28px 0 32px;
		padding: 30px 0;
		font-size: 28px;
		line-height: 40px;
		color: #727B8D;
		text-align: center;
		border-top: 1px solid #ECECEC;
		display: block;
	}

	/deep/.van-index-bar__sidebar {
		.van-index-bar__index {
			padding: 3px 22px;
			font-size: 22px;
			line-height: 26px;
			color: #13233F;
		}
	}
</style>
